import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { getNewFormsEditorBetaOptInRoute } from 'FormsUI/lib/RouteGenerators';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const FormsNewEditorBreezeOptIn = () => /*#__PURE__*/_jsx(Alert, {
  type: "warning",
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "editor.enrichmentOptInAlert.title"
  }),
  children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "editor.enrichmentOptInAlert.description_jsx",
    elements: {
      UILink: Link
    },
    options: {
      href: getNewFormsEditorBetaOptInRoute(),
      external: true
    }
  })
});
export default FormsNewEditorBreezeOptIn;